<template>
  <!-- 查询结果页 -->
  <div class="mainbox">
    <Head v-if="logo" :logo="logo"></Head>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" head-height="120">
          <div class="cont">
            <div class="touch"></div>
            <div v-if="dataList.length>0" @touchmove.stop>
              <List :dataList="dataList" @handleDetail="showDetail"   @refundChange="refundChange"  
              ></List>
              <div class="replay" @click="handlePage" v-if="iscode == false">
                <div v-if="hasmore">
                  <div v-if="pageLoading">
                    <van-loading size="24px">加载中...</van-loading>
                  </div>
                  <div v-else>
                    <van-icon name="replay" />点击加载更多数据
                  </div>
                </div>
                <div v-else>暂无更多数据</div>
              </div>
            </div>
            <div v-else class="nodata">
              <van-loading
                size="24px"
                v-if="dataList.length==0 && loading && refreshing==false"
              >加载中...</van-loading>
              <div v-if="dataList.length==0 && !loading">暂无数据</div>
            </div>
          </div>
          <!-- 支付按钮 -->
          <Foot v-if="list && list.bottomMessage && list.bottomMessage.length>0" :list="list"></Foot>
        </van-pull-refresh>
    <!-- 弹窗 -->
    <van-dialog v-model="showModel" title="收费项目明细">
      <div class="content">
        <div
          v-for="(item,index) in detailList"
          :key="index"
        >{{item.itemName}}:{{Number(item.actualAmt).toFixed(2)}}{{item.unit}}</div>
      </div>
    </van-dialog>
    <!-- 选择打印票据的缴款人弹窗 -->
    <van-dialog v-model="showSelectModel" title="选择开票单位" :before-close="beforeClose">
      <div class="paymentSelect">
        <van-radio-group v-model="selectPaymentUnit">
          <van-radio v-for="(item,index) in paymentUnitArr" :key="index" :name="item">{{item}}</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>
    <ShowDetailDialog
      :info="selectItem"
      :vde="vde"
      @closeDialog="closeDialog"
      :isShowDetail="isShowDetail"
    ></ShowDetailDialog>
    <RefundDetail :isShowDialog="isRefundShow" :refundItem="refundItem" @closeRef="closeRefDetail"></RefundDetail>
    <div id="widget" />
  </div>
</template>

<script>
import Foot from "@/components/foot";
import Head from "@/components/head";
import List from "@/components/listRefund";
import BillPhone from "@/components/billPhone"
import ShowDetailDialog from "@/components/showDetailDialog";
import { Dialog, Notify, Toast } from "vant";
import { judgeVde } from "@/utils/publicJudge";
import RefundDetail from '@/components/refundDetail'
let loadedMineMapJs = false;

export default {
  components: {
    Foot,
    Head,
    List,
    ShowDetailDialog,
    RefundDetail
  },
  data() {
    return {
      refundItem:{},
      isRefundShow:false,
      selectItem:{},
      isRefNotice:false,
      isShowBillPhone:false,
      selectPaymentUnit: "",
      paymentUnitArr: [],
      showSelectModel: false,
      active: 0,
      idCard: "",
      paymentUnit: "",
      payCode: "",
      bizNumber: "",
      type: 0,
      vde: "",
      dataList: [],
      isPay: true, //判断是否显示支付按钮
      bizId: "",
      sysType: "",
      sign: "",
      loading: true,
      usepay: true,
      mon: "",
      list: [], //温馨提示列表
      logo: "",
      picker: ["未缴费", "已缴费"],
      page: 1,
      limit: 5,
      total: 0,
      hasmore: true,
      pageLoading: false,
      iscode: false, // 是否通过扫码进入
      isSearchHistory: 0, //是否显示已缴费数据
      showModel: false,
      detailList: [],
      refreshing: false,
      showmon: "",
      checkedMark: "",
      payData: {},

      isWxmp:false,//判断是否在小程序内
      backQueryData:{ //小程序回调查询参数
        merchant_order_no:'',
        merchant_no:'',
      },
      selectRow:{},
      selectTicketDiglogVisible:false,
      selectTicketArr:[
        {label:'预收',value:'1'},
        {label:'结算',value:'2'},
      ],
      chasePay:'',
      ticketUrl:'',
      checkArr:[],//选中的数据
      isPaying:false,
      remitPayF:false,
      remitInfo:null,// 汇合缴费
      isShowDetail:false,
      deptId:'',
      paymentUnit:'',
      phone:'',
      verifiCode:''
    };
  },
  created() {
     this.vde =this.$route.query.vde?this.$route.query.vde:''
     this.deptId =this.$route.query.deptId?this.$route.query.deptId:''
     this.paymentUnit =this.$route.query.paymentUnit?this.$route.query.paymentUnit:''
     this.phone =this.$route.query.phone?this.$route.query.phone:''
    //判断vde
    judgeVde({ vde: this.vde }, this);
    let obj={
        paymentUnit:this.paymentUnit,
        phone:this.phone,
        deptId:this.deptId,
    };
    this.getDataList(obj);
    this.getFootData();
    this.getHeadImg();
  },
  destroyed() {
    Toast.clear();
  },
  mounted() {
      
  },
  methods: {
    // 如果响应的状态码为1000才表示查询成功了，否则强制回到查询页面
    getDataList(data){
      this.request({
        baseURL:process.env.VUE_APP_PAY_URL,
        url: "/refundPay/listH5RefundData",
        method: "get",
        params: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          if (res.data.result != null) {
            this.dataList = this.dataList.concat(res.data.result.list);
            this.total = res.data.result.total;
          }
          this.$forceUpdate();
        }else{
          Dialog.alert({
            title: '提示',
            message: res.data.message,
          }).then(() => {
            // this.$router.go(-1);
          });
        }
      });
    },
    refundChange(item){
      this.refundItem=item;
      this.isRefundShow=true;
    },
    showDetail(item) {
      this.selectItem = item;
      this.isShowDetail = true;
    },
    closeRefDetail(flag){
      this.isRefundShow=false;
      if(flag=='1'){
        window.location.reload();
      }
    },
    closeDialog() {
      this.selectItem = {};
      this.isShowDetail = false;
    },
    closeDia(){
       this.isShowBillPhone=false;  
       this.usepay = true;
    },
     // 初始化来源，判断是否在微信小程序内
    initFrom() {
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger") {
          //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
          wx.miniProgram.getEnv((res)=>{
            if (res.miniprogram) {
              this.isWxmp = true
            } else {
            }
          })
      }else{
      }
    },
    // 子传父的参数（用于弹窗）
    handleItem(data) {
      this.showModel = data[0];
      this.detailList = data[1];
    },
    // 下拉刷新
    async onRefresh() {
      this.page = 1;
      this.limit = 5;
      this.dataList = [];
      this.loading = true;
      let obj={
          paymentUnit:this.paymentUnit,
          phone:this.phone,
          deptId:this.deptId,
      };
      this.getDataList(obj);
      this.hasmore = true;
      this.refreshing = false;
      await Toast("刷新成功");
    },

    // 获取头像
    getHeadImg() {
      let data = {};
      data.vde = this.vde;
      this.request({
        url:'/webPortal/websitConfig',
        method:'get',
        params:data
      }).then((res)=>{
        if (res.data.code == 1000 && res.data.result.logoUrlLogin) {
          this.logo = res.data.result.logoUrlLogin;
          sessionStorage.setItem("title", res.data.result.websitTitle);
        } else if (res.data.code != 1000) {
          this.$router.push({ path: "/404" });
        } else {
          this.logo = require("../../assets/img/logo.png");
        }
      })
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 18,
      };
      this.request({
        url:'/systemManage/mobileGetMessage',
        method:'get',
        params:data
      }).then((res)=>{
          if (res.data.code != 1000) {
            //this.$router.push({ path: "/404" });
          } else {
            this.list = res.data.result;
            if (this.iscode == false) {
              this.isSearchHistory = res.data.result.isSearchHistory;

            }
          }
      })
    },
    // 分页加载更多的数据，
    handlePage() {
      this.pageLoading = true;
      if (this.dataList.length < this.total) {
        this.page++;
        this.getData();
      } else {
        setTimeout(() => {
          this.pageLoading = false;
          this.hasmore = false;
        }, 500);
      }
    },
   
    beforeClose(action, done, data) {
      if (this.selectPaymentUnit == "") {
        Notify("请选择需要开票的单位");
        done(false);
      } else {
        this.payData.payerName = this.selectPaymentUnit;
        this.remitPayF=false; //  现在把flag设置为false，也会调用beforePay
        this.initPayType(this.checkArr[0]);
        // this.beforePay(); 以前关闭窗口调的 beforePay
        done();
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.mainbox {
  padding: 0 2vw;
  box-sizing: border-box;
}
.nodata {
  text-align: center;
  font-size: 15px;
  margin: 30px 0;
  color: #888;
}
.cont {
  margin-top: 10px;
  position: relative;
  .replay {
    text-align: center;
    color: #999;
    position: relative;
    z-index: 11;
  }
  .touch {
    height: 30vh;
    width: 100vw;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }
}
.content {
  text-align: center;
  padding: 15px 0;
  line-height: 24px;
}
.btn {
  margin: 20px 0;
}
.paymentSelect {
  padding: 20px;
  text-align: center;
  .van-radio {
    margin: 10px 0;
  }
}




</style>
